import React from 'react';
import styled from 'styled-components';

interface StatCardProps {
  title: string;
  value: number;
  iconSrc: string;
  customStyles?: React.CSSProperties;
}

export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  iconSrc,
  customStyles,
}) => {
  return (
    <CardContainer styles={title === 'Total Shows'}>
      <CardContent style={customStyles}>
        <TextContainer>
          <TextWrapper>
            <StatContainer>
              <StatTitle>{title}</StatTitle>
              <StatValue>{value}</StatValue>
            </StatContainer>
          </TextWrapper>
        </TextContainer>

        <IconContainer>
          <IconImage src={iconSrc} alt={title} />
        </IconContainer>
      </CardContent>
    </CardContainer>
  );
};

interface CardContainerProps {
  styles: boolean;
}

const CardContainer = styled.article<CardContainerProps>`
  margin-top: ${props => (props.styles ? '0' : '15px')};
  width: 100%;
  font-family: Inter, -apple-system, Roboto, Helvetica, sans-serif;
  color: rgba(0, 0, 0, 1);
  font-weight: 400;
`;

const CardContent = styled.div<React.CSSProperties>`
  border-radius: 20px;
  backdrop-filter: blur(52.5px);
  display: flex;
  width: 100%;
  padding: 15px 21px;
  align-items: center;
  gap: 40px 65px;
  justify-content: space-between;
  background-color: rgba(62, 56, 56, 0.1);
  transition: all 0.2s ease-in-out;
  &:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  @media (max-width: 991px) {
    padding: 25px 20px;
  }
`;

const TextContainer = styled.div`
  align-self: stretch;
  margin-top: auto;
  margin-bottom: auto;
  width: 108px;
`;

const TextWrapper = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-between;
`;

const StatContainer = styled.div`
  display: flex;
  width: 75px;
  flex-direction: column;
  align-items: stretch;
  justify-content: start;
`;

const StatTitle = styled.h3`
  align-self: stretch;
  gap: 10px;
  font-size: 13px;
  line-height: 1;
  white-space: nowrap;
`;

const StatValue = styled.div`
  align-self: stretch;
  gap: 10px;
  font-size: 18px;
  white-space: nowrap;
  line-height: 1.4;
  color: #737272;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const IconContainer = styled.div`
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.02);
  align-self: stretch;
  display: flex;
  margin-top: auto;
  margin-bottom: auto;
  min-height: 45px;
  padding: 12px 11px;
  align-items: center;
  gap: 10px;
  justify-content: start;
  width: 45px;
  height: 45px;
`;

const IconImage = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 24px;
  align-self: stretch;
  margin-top: auto;
  margin-bottom: auto;
`;
